import React, { useContext, useEffect, useRef } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { getMetaMaskProvider } from '../../blockchainInteraction/finaliseGrading';
import { updateWallet } from '../../apis/geenpills/updateWallet';
import yellowMetaIcon from '../../assets/greenpill/yellowMetaIcon.png';
import greenpillmetamask from '../../assets/greenpill/greenpillmetamask.png';
import { useLoadingState } from '../../hooks/useLoader';
import Overlay from '../../ui/Overlay';
import { toast } from 'sonner';

function MetamaskConnection({ close, message }) {
    const myRef = useRef();
    const { loading, startLoading, stopLoading } = useLoadingState();
    const { state, dispatch } = useContext(AuthContext);
    const userProfile = state.user[0];
    const linkHandler = async () => {
        const metaMaskProvider = getMetaMaskProvider();
        if (!metaMaskProvider) {
            const installUrl = 'https://metamask.io/download.html';
            toast.info('Opening MetaMask installation page in a new tab...');
            window.open(installUrl, '_blank'); // Open the URL in a new tab
            // toast.error('MetaMask is not installed or unavailable');
            return;
        }
        const accounts = await metaMaskProvider.request({
            method: 'eth_requestAccounts',
        });

        if (!accounts || accounts.length === 0) {
            toast.error('Failed to connect wallet');
            return;
        }

        const newWallet = accounts[0]?.toLowerCase();

        const response = await updateWallet(newWallet, undefined);
        if (response?.response?.data?.code === 400) {
            toast?.error(response?.response?.data?.message);
        }

        if (response?.evmAddress) {
            // toast?.success('Wallet changed successfully');
            dispatch({ type: 'changeWalletEVM', payload: newWallet });
            // or 'phantom' depending on type
        }
    };
    useEffect(
        function () {
            function handleClick(e) {
                if (myRef.current && !myRef.current.contains(e.target)) {
                    close();
                }
            }

            document.addEventListener('click', handleClick, true);

            return () => document.removeEventListener('click', handleClick, true);
        },
        [close]
    );
    return (
        <Overlay>
            <div
                ref={myRef}
                className="absolute rounded-lg left-[50%]  p-6   bg-grayBgNormal translate-x-[-50%] translate-y-[-50%] top-[50%]"
            >
                <div className="relative ">
                    <button
                        className=" absolute top-0 right-0  rounded-full  "
                        onClick={() => {
                            close();
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                            <circle cx="15" cy="15" r="15" fill="#F3F3F3" />
                            <path
                                d="M20.5918 10L10.5914 20.0004"
                                stroke="#B2B2B2"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                            <path d="M20 20L9.99964 9.99964" stroke="#B2B2B2" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                    <div className="flex items-center justify-center">
                        <h1
                            className="text-2xl font-semibold text-textPrimary "
                            style={{
                                textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                            }}
                        >
                            <>No evm Wallet linked to profile</>
                        </h1>
                    </div>
                    <p className="text-textSecondary mt-3 mb-6 text-center ">{message}</p>
                    <div className={`flex items-center flex-col gap-3 `}>
                        <button
                            onClick={() => linkHandler('metamask')}
                            type="button"
                            className={` px-4 py-2 flex items-center gap-2 rounded-md text-white w-[12.5rem]  bg-metamask-gradient justify-between`}
                        >
                            <img className="w-7 h-7 object-cover rounded-full" src={yellowMetaIcon} alt="metamask" />
                            <span>
                                Link <span className="font-semibold">Metamask</span>{' '}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </Overlay>
    );
}

export default MetamaskConnection;
